import { PURCHASE_ORDER_REGISTER_REPORT_FAILURE, PURCHASE_ORDER_REGISTER_REPORT_REQUEST, PURCHASE_ORDER_REGISTER_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    purchaseOrderReports: {},
    loading: false,
    error: null,
  };
  
  const purchaseOrderReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_ORDER_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PURCHASE_ORDER_REGISTER_REPORT_SUCCESS: {
        return {
          ...state,
          purchaseOrderRegisterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PURCHASE_ORDER_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default purchaseOrderReportReducer;
  